import { IonContent, IonPage, IonSpinner } from '@ionic/react'
import React from 'react'

interface Props {
  message: string
}

const LoadingScreen: React.FC<Props> = props => {
  return (
    <IonPage>
      <IonContent color={'primary'}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
          }}
        >
          <IonSpinner color={'light'} />
          <p>
            {props.message}
          </p>
        </div>
      </IonContent>
    </IonPage>
  )
}

export default LoadingScreen
